(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-closer-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function find(tgt) {
    if (!tgt) return null;
    if (tgt.indexOf('claim_') === 0) return document.querySelector('[data-cc-open="' + tgt + '"]');
    return document.getElementById(tgt) || document.querySelector('[id$="__' + tgt + '"]');
  }
  function init(root) {
    if (!root || root.dataset.clInit) return;
    root.dataset.clInit = '1';
    Array.prototype.forEach.call(root.querySelectorAll('[data-cl-target]'), function (a) {
      var tgt = a.getAttribute('data-cl-target');
      if (!find(tgt)) { a.parentNode.hidden = true; return; }
      a.addEventListener('click', function (e) {
        var el = find(tgt);
        if (!el) return;
        e.preventDefault();
        if (tgt.indexOf('claim_') === 0) { el.click(); return; }
        el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cc-cl]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-gift-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function getCartEvents() {
    try { return import('@shopify/events').then(function (m) { return m.CartLinesUpdateEvent || null; }, function () { return null; }); }
    catch (e) { return Promise.resolve(null); }
  }
  function init(root) {
    if (!root || root.dataset.gpInit) return;
    root.dataset.gpInit = '1';
    var open = root.querySelector('[data-gp-open]');
    var box = root.querySelector('[data-gp-note]');
    var msg = root.querySelector('[data-gp-msg]');
    var count = root.querySelector('[data-gp-count]');
    var add = root.querySelector('[data-gp-add]');
    var addLabel = root.querySelector('[data-gp-add-label]');
    var err = root.querySelector('[data-gp-error]');
    if (!open || !box || !add) return;
    var idleLabel = addLabel.textContent;
    var max = parseInt(msg.getAttribute('maxlength'), 10) || 200;
    var key = root.getAttribute('data-note-key') || 'Gift order';
    var busy = false;

    open.addEventListener('click', function () {
      open.setAttribute('aria-expanded', 'true');
      box.hidden = false;
      msg.focus();
    });
    msg.addEventListener('input', function () { count.textContent = msg.value.length + ' / ' + max; });

    /* The set picked in the buy box at the top of the page, else the page's default variant. */
    function variantId() {
      var hero = document.querySelector('form.cc-ph__form');
      if (hero) { var v = new FormData(hero).get('id'); if (v) return String(v); }
      return root.getAttribute('data-variant');
    }
    function showError(t) { err.textContent = t; err.hidden = false; }

    add.addEventListener('click', function () {
      if (busy) return;
      busy = true; err.hidden = true;
      add.classList.add('is-busy'); addLabel.textContent = 'Adding…';
      var id = variantId();
      var note = msg.value.trim();
      var attrs = {}; attrs[key] = 'Yes';
      var update = { attributes: attrs };
      if (note) update.note = note;

      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean);
      var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
      if (ids.length) fd.append('sections', ids.join(','));

      getCartEvents().then(function (Evt) {
        var deferred = Evt && Evt.createPromise ? Evt.createPromise() : null;
        if (deferred) root.dispatchEvent(new Evt({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
        var added = null;
        function refresh() { return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
        function settle(cart, failed) {
          if (!deferred) return;
          deferred.resolve({ cart: Evt.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'cc-gift-panel', itemCount: 1, sections: added && added.sections, didError: failed } });
        }
        return fetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(update) })
          .then(function (r) { if (!r.ok) throw new Error('note'); return r.json(); })
          .then(function () { return fetch(rootUrl() + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }); })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); })
          .then(function (d) {
            added = d;
            return refresh().then(function (cart) {
              settle(cart, false);
              if (!deferred) { var td = document.querySelector('cart-drawer-component'); td = td && td.closest('theme-drawer'); if (td && td.open) td.open(); }
              addLabel.textContent = note ? 'Added — your note is with the order' : 'Added as a gift';
              setTimeout(function () { busy = false; addLabel.textContent = idleLabel; }, 2400);
            });
          })
          .catch(function (e) {
            busy = false; addLabel.textContent = idleLabel;
            showError((e && (e.description || (e.message && e.message !== 'note' ? e.message : ''))) || 'That did not go through. Please try again.');
            refresh().then(function (cart) { settle(cart, true); }, function () {});
          });
      }).then(function () { add.classList.remove('is-busy'); });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cc-gp]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-gifting-final"]) return;
  try {
    

(() => {
 function setup() {
  const root = document.getElementById('cc-final');
  if (!root || root.dataset.enhanced) return;
  root.dataset.enhanced = 'true';
  const find = id => root.querySelector('#' + id);
  const form = find('final-form');
  if (!form) return;
  const qOcc = new URLSearchParams(location.search).get('occasion');
  if (qOcc) { const oc = find('final-occasion'); if (oc && !oc.value) oc.value = qOcc; }
  let gc = '';
  try {
   const q = new URLSearchParams(location.search);
   gc = q.get('gclid') || (q.get('gbraid') ? 'gbraid:' + q.get('gbraid') : '') || (q.get('wbraid') ? 'wbraid:' + q.get('wbraid') : '');
   if (gc) localStorage.setItem('ccGclid', JSON.stringify({ v: gc, t: Date.now() }));
   else { const saved = JSON.parse(localStorage.getItem('ccGclid') || 'null'); if (saved && Date.now() - saved.t < 7776000000) gc = saved.v; }
  } catch (e) {}
  if (gc) root.querySelectorAll('.cc-gclid').forEach(i => { i.value = gc; });
  const SENT = 'ccGiftLead';
  const store = { get: k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  function enquire() { find('final-enquiry').scrollIntoView({block:'start'}); const n = find('final-name'); if (n) n.focus({preventScroll:true}); }
  root.querySelectorAll('[data-product]').forEach(link => link.addEventListener('click', () => {
   const st = find('final-style'), sel = find('final-selection');
   if (st) st.value = link.dataset.product;
   if (sel) { sel.textContent = root.dataset.selectionLabel + ' ' + link.dataset.product; sel.hidden = false; }
   enquire();
  }));
  root.querySelectorAll('[data-occasion]').forEach(link => link.addEventListener('click', () => { const o = find('final-occasion'); if (o) o.value = link.dataset.occasion; enquire(); }));
  function beacon(f, type) {
   f.addEventListener('submit', () => {
    store.set(SENT, '1');
    const hook = window.CC_FORMS_WEBHOOK;
    if (!hook) return;
    try {
     const v = n => { const el = f.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
     const o = { _type: type, _page: location.pathname, _when: new Date().toISOString(), Name: v('name'), Phone: v('phone'), email: v('email'), Occasion: v('Occasion'), 'Selected style': v('Selected style'), 'Enquiry type': v('Enquiry type'), gclid: v('gclid') };
     navigator.sendBeacon(hook, new Blob([JSON.stringify(o)], {type: 'text/plain'}));
    } catch (e) {}
   });
  }
  beacon(form, 'Gifting enquiry');
  const pop = find('final-pop');
  const floatForm = document.getElementById('cc-float-form');
  if (floatForm) floatForm.addEventListener('click', () => {
   if (pop && !pop.open && typeof pop.showModal === 'function') { pop.showModal(); store.set('ccGiftPopSeen', '1'); const first = pop.querySelector('input:not([type=hidden])'); if (first) setTimeout(() => first.focus(), 60); }
   else enquire();
  });
  if (pop) {
   const popForm = pop.querySelector('form');
   if (popForm) beacon(popForm, 'Gifting enquiry (pop-up)');
   const close = () => { try { pop.close(); } catch (e) { pop.removeAttribute('open'); } };
   pop.querySelector('[data-pop-close]').addEventListener('click', close);
   pop.addEventListener('click', e => { if (e.target === pop) close(); });
   pop.addEventListener('close', () => store.set('ccGiftPopSeen', '1'));
   const posted = /[?&]contact_posted=true/.test(location.search);
   if (posted) store.set(SENT, '1');
   if (posted && /final-pop-form/.test(location.hash)) { const en = find('final-enquiry'); if (en) setTimeout(() => en.scrollIntoView({block:'start'}), 300); }
   const trigger = find('final-difference') || find('final-collection');
   const open = () => {
    if (store.get(SENT) || store.get('ccGiftPopSeen') || pop.open || document.querySelector('dialog[open]')) return;
    if (typeof pop.showModal === 'function') pop.showModal(); else pop.setAttribute('open', '');
    store.set('ccGiftPopSeen', '1');
   };
   if (trigger && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
    const io = new IntersectionObserver(entries => { if (entries.some(en => en.isIntersecting)) { io.disconnect(); setTimeout(open, 400); } }, {threshold: 0.25});
    io.observe(trigger);
   }
  }
  root.querySelectorAll('[data-carousel]').forEach(car => {
   const track = car.querySelector('[data-track]');
   const prev = car.querySelector('[data-prev]');
   const next = car.querySelector('[data-next]');
   const bar = car.querySelector('[data-bar]');
   const stepSize = () => { const c = track.querySelector('.product'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
   const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
    bar.style.width = Math.min(100, ratio * 100) + '%';
    bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
   };
   prev.addEventListener('click', () => track.scrollBy({left: -stepSize()}));
   next.addEventListener('click', () => track.scrollBy({left: stepSize()}));
   track.addEventListener('scroll', update, {passive: true});
   window.addEventListener('resize', update);
   track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); } if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); } });
   let down = false, moved = false, startX = 0, startLeft = 0;
   track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; });
   window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - startX; if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); } if (moved) track.scrollLeft = startLeft - dx; });
   window.addEventListener('pointerup', () => { if (!down) return; down = false; if (moved) { track.classList.remove('is-dragging'); const s = stepSize(); track.scrollTo({left: Math.round(track.scrollLeft / s) * s}); } });
   track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
   update();
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
 document.addEventListener('shopify:section:load', setup);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  /* Delivery: 5 PM IST cut-off, Sunday is not a dispatch or transit day, 2 days to nearby zones, 3 everywhere else. */
  var CUTOFF = 17;
  var ZONE2 = { 11:'A',12:'A',13:'A',20:'A',21:'A',22:'A',23:'A',24:'A',25:'A',26:'A',27:'A',28:'A',30:'A',
    14:'B',15:'B',16:'B',31:'B',32:'B',33:'B',34:'B',45:'B',46:'B',47:'B',80:'B',81:'B',82:'B',84:'B',85:'B',
    17:'C',36:'C',37:'C',38:'C',39:'C',40:'C',41:'C',42:'C',43:'C',44:'C',48:'C',49:'C',50:'C',51:'C',52:'C',
    53:'C',56:'C',57:'C',58:'C',59:'C',60:'C',61:'C',62:'C',63:'C',64:'C',67:'C',68:'C',69:'C',70:'C',71:'C',
    72:'C',73:'C',74:'C',75:'C',76:'C',77:'C',83:'C', 18:'D',19:'D',78:'D',79:'D' };
  var ZONE3 = { 737:'D', 744:'D' };
  var TRANSIT = { A:2, B:3, C:3, D:3 };
  var PIN_KEY = 'cc_pin';
  var PIN_AGE = 2592000000;
  var AMOUNT_RE = new RegExp('\\{\\{\\s*\\w+\\s*\\}\\}');

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function init(root) {
    if (!root || root.dataset.phInit) return;
    root.dataset.phInit = '1';
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var FMT = root.getAttribute('data-money-format') || '';
    var ADD = root.getAttribute('data-add-label') || 'Add to bag';
    var CONTACT = root.getAttribute('data-contact') || '';
    var variants = [];
    try { variants = JSON.parse(($('[data-ph-variants]') || {}).textContent || '[]'); } catch (e) {}

    function money(cents) {
      var a = cents / 100;
      var parts = (a % 1 === 0 ? a.toFixed(0) : a.toFixed(2)).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var num = parts.join('.');
      return AMOUNT_RE.test(FMT) ? FMT.replace(AMOUNT_RE, num) : '₹' + num;
    }

    /* ---------- gallery ---------- */
    var track = $('[data-ph-track]');
    var slides = $$('[data-ph-slide]');
    var thumbs = $$('[data-ph-thumb]');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      var t = thumbs[i];
      var strip = $('[data-ph-thumbs]');
      if (t && strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: reduced() ? 'auto' : 'smooth' });
      }
    }
    function goTo(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduced() ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      track.addEventListener('click', function (e) { if (e.target.closest('[data-ph-slide]')) openLb(current); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ph-thumb'), 10) || 0); }); });

    /* ---------- lightbox ---------- */
    var lb = $('[data-ph-lb]');
    var lbImg = $('[data-ph-lb-img]');
    var lbView = $('[data-ph-lb-view]');
    var lbCount = $('[data-ph-lb-count]');
    var lbIndex = 0;
    function lbShow(i) {
      if (!lb || !slides.length) return;
      lbIndex = (i + slides.length) % slides.length;
      lb.classList.remove('is-zoomed');
      var sl = slides[lbIndex];
      var img = sl.querySelector('img');
      lbImg.src = sl.getAttribute('data-zoom');
      lbImg.alt = img ? img.alt : '';
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + slides.length;
    }
    function openLb(i) {
      if (!lb || typeof lb.showModal !== 'function') return;
      lbShow(i);
      lb.showModal();
      document.documentElement.classList.add('cc-ph-lock');
    }
    if (lb) {
      $('[data-ph-zoom]').addEventListener('click', function () { openLb(current); });
      $('[data-ph-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('close', function () { document.documentElement.classList.remove('cc-ph-lock'); if (lbIndex !== current) goTo(lbIndex, true); });
      var prevB = $('[data-ph-lb-prev]'), nextB = $('[data-ph-lb-next]');
      if (prevB) prevB.addEventListener('click', function () { lbShow(lbIndex - 1); });
      if (nextB) nextB.addEventListener('click', function () { lbShow(lbIndex + 1); });
      lb.addEventListener('keydown', function (e) {
        if (lb.classList.contains('is-zoomed')) return;
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
        if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      });
      lbImg.addEventListener('click', function (e) {
        var r = lbImg.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        if (lb.classList.toggle('is-zoomed')) {
          requestAnimationFrame(function () {
            lbView.scrollLeft = fx * lbImg.offsetWidth - lbView.clientWidth / 2;
            lbView.scrollTop = fy * lbImg.offsetHeight - lbView.clientHeight / 2;
          });
        }
      });
    }

    /* ---------- variant, quantity, price ---------- */
    var form = $('form.cc-ph__form');
    var radios = $$('[data-ph-variant]');
    var addBtn = $('[data-ph-add]');
    var addLabel = $('[data-ph-add-label]');
    var priceEl = $('[data-ph-price]');
    var compareEl = $('[data-ph-compare]');
    var capEl = $('[data-ph-caption]');
    var stockEl = $('[data-ph-stock]');
    var errEl = $('[data-ph-error]');
    var sticky = $('[data-ph-sticky]');
    var sPrice = $('[data-ph-sticky-price]');
    var sName = $('[data-ph-sticky-name]');
    var sAdd = $('[data-ph-sticky-add]');
    var pin = $('[data-ph-pin]');
    var busy = false;

    function selectedId() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (r) return parseInt(r.value, 10);
      var single = $('[data-ph-single]');
      return single ? parseInt(single.value, 10) : 0;
    }
    function variant() {
      var id = selectedId();
      return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
    }
    function render() {
      var v = variant(); if (!v) return;
      var one = money(v.price);
      priceEl.textContent = one;
      if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare ? money(v.compare) : ''; }
      if (capEl) capEl.textContent = v.caption || '';
      radios.forEach(function (r) { r.closest('.cc-ph__set').classList.toggle('is-checked', r.checked); });
      if (!busy) addLabel.textContent = v.available ? ADD + ' — ' + money(v.price) : 'Sold out';
      addBtn.disabled = !v.available;
      if (stockEl) stockEl.hidden = !v.available;
      if (sPrice) sPrice.textContent = one;
      if (sName) sName.textContent = radios.length ? v.name : '';
      if (sAdd) sAdd.disabled = !v.available;
      if (pin) pin.classList.toggle('is-off', !v.available);
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (errEl) errEl.hidden = true;
        render();
        var v = variant();
        if (v && v.media > -1) goTo(v.media);
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
      });
    });

    /* ---------- add to bag ---------- */
    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
    /* Talks to the theme's cart the same way its own product form does: a Shopify
       standard CartLinesUpdateEvent, resolved with the fresh cart and the re-rendered
       drawer sections, so the drawer opens and the bag count updates. */
    function getCartEvents() {
      try { return import('@shopify/events').then(function (m) { return m.CartLinesUpdateEvent || null; }, function () { return null; }); }
      catch (e) { return Promise.resolve(null); }
    }
    function addToBag() {
      if (busy || addBtn.disabled || !form) return;
      busy = true;
      addBtn.classList.add('is-busy');
      addLabel.textContent = 'Adding…';
      if (errEl) errEl.hidden = true;

      var fd = new FormData(form);
      var n = parseInt(fd.get('quantity'), 10) || 1;
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean);
      if (ids.length) fd.append('sections', ids.join(','));

      getCartEvents().then(function (Evt) {
        var deferred = Evt && Evt.createPromise ? Evt.createPromise() : null;
        if (deferred) form.dispatchEvent(new Evt({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: n }], promise: deferred.promise }));
        var added = null;
        function refresh() { return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
        function settle(cart, failed) {
          if (!deferred) return;
          deferred.resolve({ cart: Evt.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'cc-product-hero', itemCount: n, sections: added && added.sections, didError: failed } });
        }
        return fetch(rootUrl() + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); })
          .then(function (d) {
            added = d;
            return refresh().then(function (cart) {
              settle(cart, false);
              if (!deferred) { var td = document.querySelector('cart-drawer-component'); td = td && td.closest('theme-drawer'); if (td && td.open) td.open(); }
              addLabel.textContent = 'Added to bag';
              setTimeout(function () { busy = false; render(); }, 1600);
            });
          })
          .catch(function (err) {
            busy = false;
            showError((err && (err.description || err.message)) || 'That did not go through. Please try again.');
            render();
            refresh().then(function (cart) { settle(cart, true); }, function () {});
          });
      }).then(function () { addBtn.classList.remove('is-busy'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToBag(); });
    if (sAdd) sAdd.addEventListener('click', addToBag);

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sAdd) sAdd.tabIndex = show ? 0 : -1;
      }, { threshold: 0 }).observe(addBtn);
    }

    /* ---------- links ---------- */
    function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }
    function nextSection() { var sec = root.closest('.shopify-section'); return sec ? sec.nextElementSibling : null; }
    var details = $('[data-ph-details]');
    if (details) details.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.querySelector('.cc-det');
      scrollToEl(t ? (t.closest('.shopify-section') || t) : nextSection());
    });
    $$('[data-ph-breakage]').forEach(function (breakage) { breakage.addEventListener('click', function () {
      var id = root.getAttribute('data-breakage');
      var opener = id ? document.querySelector('[data-cc-open="' + id + '"]') : null;
      if (opener) { opener.click(); return; }
      scrollToEl(document.querySelector('[data-cc-as]') || nextSection());
    }); });
    var nextBtn = $('[data-ph-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToEl(nextSection()); });

    /* ---------- pincode delivery check ---------- */
    if (pin) {
      var tag = $('[data-ph-pin-tag]');
      var body = $('[data-ph-pin-body]');
      var tagIdle = tag.textContent;
      var idleHTML = body.innerHTML;
      var eta = $('[data-ph-eta]');

      var istNow = function () { var d = new Date(); return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 19800000); };
      var addDays = function (d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; };
      var dispatchDay = function (now) { var x = new Date(now.getTime()); if (x.getHours() >= CUTOFF) x = addDays(x, 1); while (x.getDay() === 0) x = addDays(x, 1); return x; };
      var addTransit = function (d, n) { var x = new Date(d.getTime()); var i = 0; while (i < n) { x = addDays(x, 1); if (x.getDay() !== 0) i++; } return x; };
      var longDate = function (d) { return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONS[d.getMonth()]; };
      var shortDate = function (d) { return DAYS[d.getDay()].slice(0, 3) + ', ' + d.getDate() + ' ' + MONS[d.getMonth()].slice(0, 3); };
      var lookup = function (p) { var z = ZONE3[p.slice(0, 3)] || ZONE2[p.slice(0, 2)] || 'C'; return addTransit(dispatchDay(istNow()), TRANSIT[z]); };

      var setEta = function (text) { if (!eta) return; eta.hidden = !text; eta.textContent = text ? 'Arrives ' + text : ''; };
      var save = function (p) { try { localStorage.setItem(PIN_KEY, JSON.stringify({ p: p, t: Date.now() })); } catch (e) {} };
      var clear = function () { try { localStorage.removeItem(PIN_KEY); } catch (e) {} };
      var load = function () { try { var v = JSON.parse(localStorage.getItem(PIN_KEY) || 'null'); if (v && v.p && Date.now() - v.t < PIN_AGE) return v.p; } catch (e) {} return null; };

      var reset;
      var renderResult = function (p) {
        var d = lookup(p);
        tag.textContent = p;
        body.innerHTML =
          '<div class="cc-ph__pin-card">' +
            '<p class="cc-ph__pin-top"><span>Delivers to ' + esc(p) + '</span><button type="button" class="cc-ph__pin-change" data-ph-pin-reset>Change</button></p>' +
            '<p class="cc-ph__pin-date">Arrives by ' + longDate(d) + '</p>' +
            '<dl class="cc-ph__pin-rows">' +
              '<div class="cc-ph__pin-row"><dt>Shipping</dt><dd>Free</dd></div>' +
              '<div class="cc-ph__pin-row"><dt>Cash on delivery</dt><dd>Available</dd></div>' +
              '<div class="cc-ph__pin-row"><dt>Returns</dt><dd>7 days</dd></div>' +
            '</dl>' +
            '<p class="cc-ph__pin-foot">Unused, in its box. We arrange the pickup at no charge.' + (CONTACT ? ' Questions: <a href="mailto:' + esc(CONTACT) + '">' + esc(CONTACT) + '</a>' : '') + '</p>' +
          '</div>';
        setEta(shortDate(d) + ' · ' + p);
        var r = body.querySelector('[data-ph-pin-reset]');
        if (r) r.addEventListener('click', reset);
      };
      var check = function (p) {
        var field = body.querySelector('[data-ph-pin-field]');
        var help = body.querySelector('[data-ph-pin-help]');
        if (!/^[1-8]\d{5}$/.test(p)) {
          if (field) field.classList.add('is-error');
          if (help) { help.classList.add('is-error'); help.textContent = 'Please enter a 6-digit pincode, like 110001.'; }
          return;
        }
        save(p); renderResult(p);
      };
      var bindIdle = function () {
        var input = body.querySelector('[data-ph-pin-input]');
        var go = body.querySelector('[data-ph-pin-go]');
        var field = body.querySelector('[data-ph-pin-field]');
        var help = body.querySelector('[data-ph-pin-help]');
        var helpIdle = help ? help.textContent : '';
        if (!input || !go) return;
        input.addEventListener('input', function () {
          this.value = this.value.replace(/\D/g, '').slice(0, 6);
          if (field) field.classList.remove('is-error');
          if (help && help.classList.contains('is-error')) { help.classList.remove('is-error'); help.textContent = helpIdle; }
          if (this.value.length === 6) check(this.value);
        });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(this.value); } });
        go.addEventListener('click', function () { check(input.value); });
      };
      reset = function () {
        clear(); setEta('');
        tag.textContent = tagIdle;
        body.innerHTML = idleHTML;
        bindIdle();
        var i = body.querySelector('[data-ph-pin-input]'); if (i) i.focus();
      };
      bindIdle();
      var saved = load();
      if (saved && /^[1-8]\d{5}$/.test(saved)) renderResult(saved);
    }

    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cc-ph]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
